import { Activity, ClipboardList, Mail, Users } from "lucide-react";
import { lazy } from "react";

import type { TabRoute } from "@/lib/routes";

// Lazy-loaded so opening one tab does not pull the others.
const ClientRosterTab = lazy(() => import("./ClientRosterTab"));
const CommunicationsTab = lazy(() => import("./CommunicationsTab"));
const DrTrackingTab = lazy(() => import("./DrTrackingTab"));
const PeakTrackingTab = lazy(() => import("./PeakTrackingTab"));

/**
 * Child tab routes for `/dr-peak-shaving` (AB#8451).
 *
 * Declared here rather than inline in the route table so the parent page can
 * import the list without a circular import — the route table already
 * imports the parent page.
 *
 * Order follows the tickets: AB#8451 named the first three in this
 * sequence, and AB#8796 puts DR Tracking between Communications and Peak
 * Tracking. It is a deliberate reading order, not an alphabetical list.
 */
export const DR_PEAK_SHAVING_TAB_ROUTES: ReadonlyArray<TabRoute> = [
  {
    path: "roster",
    label: "Client Roster",
    icon: Users,
    element: <ClientRosterTab />,
  },
  {
    path: "communications",
    label: "Communications",
    icon: Mail,
    element: <CommunicationsTab />,
  },
  {
    path: "dr-tracking",
    label: "DR Tracking",
    icon: ClipboardList,
    element: <DrTrackingTab />,
  },
  {
    path: "peak-tracking",
    label: "Peak Tracking",
    icon: Activity,
    element: <PeakTrackingTab />,
  },
];
